module.exports = __webpack_public_path__ + "img/9-4.5500a6ad.png";